/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserPlus} from '@fortawesome/pro-duotone-svg-icons';

const AddGuardianIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUserPlus} {...props} />
);

export default AddGuardianIcon;
